import React from "react";

import {
  Settings,
  // Info,
  Library,
  // CloudUpload,
  Archive,
  User,
  Bookmark,
} from "lucide-react";

import style from "./DesktopNav.module.scss";

//Components
import Logo from "../../../ui/Logo/Logo";
import NavItem from "../NavItem";

const DesktopNav = () => {
  const isAuth = false;

  const onClickgout = () => {};

  return (
    <nav className={style.nav}>
      <Logo />
      <div className={style.navContent}>
        <div className={style.navSection}>
          <NavItem to="/lib" title={"lib"} Icon={Library} />

          <NavItem to="/bookmark" title={"bookmark"} Icon={Bookmark} />
        </div>
        <div className={style.navSection}>
          <NavItem to="/profile" title={"profile"} Icon={User} />

          {/* <NavItem to="/upload" title={"upload(!)"} Icon={CloudUpload} /> */}
          <NavItem to="/forum" title={"forum"} Icon={Archive} />
          <NavItem to="/settings" title={"settings"} Icon={Settings} />
        </div>
      </div>
    </nav>
  );
};

export default DesktopNav;
